import React, { Component } from 'react';
import ContentWrapper from '../../components/ContentWrapper';

import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { push } from 'react-router-redux';

import Page from '@atlaskit/page';

import {
  logoutAsync
} from '../../reducers/account';

class Logout extends Component {

  componentDidMount = () => {
    this.props.logoutAsync();
  }

  render() {

    if(!this.props.loggedIn) {
      this.props.goToLogin();
    }

    return (
      <Page>
        <ContentWrapper>
          <div id="logout">
            <div className="container" style={{marginTop: '100px'}}>
              <div className="row">
                <div className="col-md-12">
                  <h4>Logging Out...</h4>
                </div>
              </div>
            </div>
          </div>
        </ContentWrapper>
      </Page>
    )
  }
}


const mapStateToProps = state => ({
  loggedIn: state.account.loggedIn,
});

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      logoutAsync,
      goToLogin: () => push('/login')
    },
    dispatch
  );

export default connect(mapStateToProps, mapDispatchToProps)(Logout);


// WEBPACK FOOTER //
// ./src/modules/Logout/Logout.js